// r125 gen 2 - done
// z1000 - done
// 650 ninja - done
// z650  - done
// gasgas — done
// z800 — done
// z900 — done
// rs660 — done
// XJ6 — done
// tracer 9 — done
// z400/ z250
// ninja 400 / ninja 250
// cb500f 2016-2023
// Lexmoto
// sinnis
// gsxr 125
// fireblade 2017
// fireblade rr7
// CBR600RR 
// unfucked the gsxrs
// CB125R - CB300R
// SPEED TRIPLE 1200 RS
// tmax 560
// T7
// TMAX 530
// EXC
// 2024 CBR650R
// ADD RC 300
// benelli bn
// wr450
// SV650
// 1290 gen 3 low
// CB1000R
// DAYTONA 660
// tracer 9 gt
// 990 duke
// 1390 duke
// cb1000 hornet
// cb1000r 2008-2017



var oldmodels = [
  {
     brand: "Benelli",
     model: "BN 125",
     years: ["2021 - 2024"],
     link: "https://flipndip.co.uk/products/benelli-bn-125?utm_source=bike-selector",
   },
  {
     brand: "Yamaha",
     model: "T-Max 560",
     years: ["2022"],
     link: "https://flipndip.co.uk/products/yamaha-t-max-560?utm_source=bike-selector",
   },
    {
     brand: "Yamaha",
     model: "WR450F",
     years: ["2018 - 2024"],
     link: "https://flipndip.co.uk/collections/yamaha/products/yamaha-wr450f?utm_source=bike-selector",
   },
    {
     brand: "Yamaha",
     model: "T-Max 530",
     years: ["2012 - 2016"],
     link: "https://flipndip.co.uk/products/yamaha-t-max-530?utm_source=bike-selector",
   },
     {
     brand: "KTM",
     model: "EXC 250/350/450/500",
     years: ["2020 - 2022"],
     link: "https://flipndip.co.uk/products/ktm-exc?utm_source=bike-selector",
   },
  {
     brand: "Triumph",
     model: "Speed Triple 1200 RS",
     years: ["2021 - 2024"],
     link: "https://flipndip.co.uk/collections/triumph/products/triumph-street-triple-1200-rs-rr?utm_source=bike-selector",
   },
  {
     brand: "Triumph",
     model: "Speed Triple 1200 RR",
     years: ["2022"],
     link: "https://flipndip.co.uk/collections/triumph/products/triumph-street-triple-1200-rs-rr?utm_source=bike-selector",
   },
  {
     brand: "Honda",
     model: "CB125R",
     years: ["2018 - 2024"],
     link: "https://flipndip.co.uk/collections/honda/products/honda-cb125r?utm_source=bike-selector",
   },
 {
     brand: "Honda",
     model: "CB1000 Hornet",
     years: ["2025+"],
     link: "https://flipndip.co.uk/collections/honda/products/honda-cb125r?utm_source=bike-selector",
   },
  
    {
     brand: "Honda",
     model: "CB300R",
     years: ["2018 - 2020, 2024"],
     link: "https://flipndip.co.uk/collections/honda/products/honda-cb300r?utm_source=bike-selector",
   },
     {
     brand: "Honda",
     model: "CB1000R",
     years: ["2018+", "2008 - 2017"],
     link: [
       "https://flipndip.co.uk/products/honda-cb1000r?variant=55195250229635&utm_source=bike-selector",
       "https://flipndip.co.uk/products/honda-cb1000r?variant=55195250262403&utm_source=bike-selector",
     ],
   },
  {
     brand: "Sinnis",
     model: "GPX 125",
     years: ["2022 - 2024"],
     link: "https://flipndip.co.uk/products/sinnis-gpx?utm_source=bike-selector",
   },
  {
     brand: "Lexmoto",
     model: "LXR 125",
     years: ["2021 - 2024"],
     link: "https://flipndip.co.uk/products/lexmoto-lxr?utm_source=bike-selector",
   },
   {
     brand: "Suzuki",
     model: "GSXR 125",
     years: ["2017 - 2024"],
     link: "https://flipndip.co.uk/products/suzuki-gsxr-125?utm_source=bike-selector",
   },
  {
     brand: "Suzuki",
     model: "SV650",
     years: ["2003 - 2012"],
     link: "https://flipndip.co.uk/products/suzuki-sv650?utm_source=bike-selector",
   },
  
   {
     brand: "Suzuki",
     model: "GSXS 125",
     years: ["2017 - 2024"],
     link: "https://flipndip.co.uk/products/suzuki-gsxs-125?utm_source=bike-selector",
   },
  {
     brand: "Ducati",
     model: "Panigale V2",
     years: ["2020 - 2023"],
     link: "https://flipndip.co.uk/products/ducati-panigale-v4-v2-streetfighter-v4?utm_source=bike-selector",
   },
   {
     brand: "Ducati",
     model: "Panigale V4",
     years: ["2017 - 2019"],
     link: "https://flipndip.co.uk/products/ducati-panigale-v4-v2-streetfighter-v4?utm_source=bike-selector",
   },
    {
     brand: "Ducati",
     model: "Panigale V4 R",
     years: ["2020"],
     link: "https://flipndip.co.uk/products/ducati-panigale-v4-v2-streetfighter-v4?utm_source=bike-selector",
   },
    {
     brand: "Ducati",
     model: "Panigale V4S",
     years: ["2018 - 2023"],
     link: "https://flipndip.co.uk/products/ducati-panigale-v4-v2-streetfighter-v4?utm_source=bike-selector",
   },
    {
     brand: "Ducati",
     model: "Streetfighter V2",
     years: ["2022 - 2023"],
     link: "https://flipndip.co.uk/products/ducati-panigale-v4-v2-streetfighter-v4?utm_source=bike-selector",
   },
  {
     brand: "Ducati",
     model: "Streetfighter V4",
     years: ["2020 - 2023"],
     link: "https://flipndip.co.uk/products/ducati-panigale-v4-v2-streetfighter-v4?utm_source=bike-selector",
   },
  {
     brand: "Ducati",
     model: "Streetfighter V4 S",
     years: ["2020 - 2023"],
     link: "https://flipndip.co.uk/products/ducati-panigale-v4-v2-streetfighter-v4?utm_source=bike-selector",
   },
  {
     brand: "GasGas",
     model: "SM 700",
     years: ["2022+"],
     link: "https://flipndip.co.uk/products/gasgas-sm-700?utm_source=bike-selector",
   },
  {
     brand: "Aprilia",
     model: "RSV4 RF",
     years: ["2015 - 2019"],
     link: "https://flipndip.co.uk/collections/aprilia/products/aprilia-rsv4?utm_source=bike-selector",
   },
  {
     brand: "Aprilia",
     model: "RS660",
     years: ["2021 - 2024"],
     link: "https://flipndip.co.uk/collections/aprilia/products/aprilia-rs660?utm_source=bike-selector",
   },
  {
     brand: "Aprilia",
     model: "Tuono 660",
     years: ["2021+"],
     link: "https://flipndip.co.uk/collections/aprilia/products/aprilia-rs660?utm_source=bike-selector",
   },
   {
     brand: "Aprilia",
     model: "RSV4 RR",
     years: ["2015 - 2019"],
     link: "https://flipndip.co.uk/collections/aprilia/products/aprilia-rsv4?utm_source=bike-selector",
   },

   {
     brand: "Aprilia",
     model: "Tuono V4 Factory",
     years: ["2015 - 2021"],
     link: "https://flipndip.co.uk/collections/aprilia/products/aprilia-rsv4?utm_source=bike-selector",
   },
   
   {
     brand: "BMW",
     model: "S1000RR",
     years: ["2008 - 2018", "2019 - 2023"],
     link: {
        "2008 - 2018": "https://flipndip.co.uk/collections/bmw/products/bmw-s1000rr-flip-plate?utm_source=bike-selector",
        "2019 - 2023": "https://flipndip.co.uk/collections/bmw/products/bmw-s1000rr-flip-plate?variant=40855032070334&utm_source=bike-selector" 
            },
   },

   {
     brand: "BMW",
     model: "S1000R",
     years: ["2013 - 2024"],
     link: "https://flipndip.co.uk/collections/bmw/products/bmw-s1000rr-flip-plate?variant=40855032070334&utm_source=bike-selector",
   },

   {
     brand: "Gilera",
     model: "Runner 50cc, 125cc, 200cc",
     years: ["2006 - Present"],
     link: "https://flipndip.co.uk/collections/gilera/products/gilera-runner?utm_source=bike-selector",
   },

   {
     brand: "Honda",
     model: "CB500F",
     years: ["2016 - 2023"],
     link: "https://flipndip.co.uk/products/honda-cb500?utm_source=bike-selector",
   },
     {
     brand: "Honda",
     model: "MSX/Grom",
     years: ["2014 - 2019", "2020 - 2024"],
     link: {
       "2014 - 2019": "https://flipndip.co.uk/collections/honda/products/honda-msx-grom-flip-n-dip-adjustable-bracket?utm_source=bike-selector",
       "2020 - 2024": "https://flipndip.co.uk/collections/honda/products/honda-msx-grom-flip-n-dip-adjustable-bracket?variant=43396679598270&utm_source=bike-selector"
     }
   },

   {
     brand: "Honda",
     model: "Grom with Stunt Savage Cage",
     years: ["N/A"],
     link: "https://flipndip.co.uk/collections/honda/products/honda-grom-ssc-12-bar?utm_source=bike-selector",
   },

   {
     brand: "Honda",
     model: "CBR1000RR Fireblade",
     years: ["2006 - 2007", "2008 - 2013", "2017 - 2019"],
     link: {
       "2004 - 2007": "https://flipndip.co.uk/collections/honda/products/honda-cbr1000rr?variant=43312840016062&utm_source=bike-selector",
       "2008 - 2013": "https://flipndip.co.uk/collections/honda/products/honda-cbr1000rr?variant=43630197145790&utm_source=bike-selector",
       "2017 - 2019": "https://flipndip.co.uk/collections/honda/products/honda-cbr1000rr?variant=43630197178558&utm_source=bike-selector",
     },
   },
    {
     brand: "Honda",
     model: "CBR600RR",
     years: ["2003 - 2006"],
     link: "https://flipndip.co.uk/collections/honda/products/honda-cbr600rr?utm_source=bike-selector",
   },

   {
     brand: "Honda",
     model: "CB650R / CBR650R",
     years: ["2019 - 2020", "2021 - 2024"],
     link: {
       "2019 - 2020": "https://flipndip.co.uk/collections/honda/products/honda-cbr650r-cb650r-flip-n-dip-adjustable-bracket?variant=42534690750654&utm_source=bike-selector",
       "2021 - 2024": "https://flipndip.co.uk/collections/honda/products/honda-cbr650r-cb650r-flip-n-dip-adjustable-bracket?variant=42534690783422&utm_source=bike-selector"
     },
   },



   {
     brand: "Honda",
     model: "CB650F",
     years: ["2014 - 2022"],
     link: "https://flipndip.co.uk/collections/honda/products/honda-cb650f?utm_source=bike-selector",
   },

   {
     brand: "Husqvarna",
     model: "701 SM",
     years: ["2016 +"],
     link: "https://flipndip.co.uk/collections/husqvarna/products/husqvarna-701-sm?utm_source=bike-selector",
   },

   {
     brand: "Kawasaki",
     model: "ZX6R",
     years: ["2009 - 2024"],
     link: "https://flipndip.co.uk/collections/kawasaki/products/kawasaki-ninja-636?utm_source=bike-selector",
   },

   {
     brand: "Kawasaki",
     model: "ZX10R",
     years: ["2008 - 2010", "2011 - 2015", "2016 - 2020"],
     link: {
       "2008 - 2010": "https://flipndip.co.uk/collections/kawasaki/products/kawasaki-zx10r?variant=42568481964222&utm_source=bike-selector",
       "2011 - 2015": "https://flipndip.co.uk/collections/kawasaki/products/kawasaki-zx10r?variant=42721391149246&utm_source=bike-selector",
       "2016 - 2020": "https://flipndip.co.uk/collections/kawasaki/products/kawasaki-zx10r?variant=42568481931454&utm_source=bike-selector"
     },
   },
     {
     brand: "Kawasaki",
     model: "Z1000",
     years: ["2014 - 2023"],
     link: "https://flipndip.co.uk/collections/kawasaki/products/kawasaki-z1000?utm_source=bike-selector",
   },
      {
     brand: "Kawasaki",
     model: "Z800",
     years: ["2013 - 2016"],
     link: "https://flipndip.co.uk/collections/kawasaki/products/kawasaki-z800?utm_source=bike-selector",
   },
     {
     brand: "Kawasaki",
     model: "Z900",
     years: ["2017+"],
     link: "https://flipndip.co.uk/collections/kawasaki/products/kawasaki-z900?utm_source=bike-selector",
   },

     {
     brand: "Kawasaki",
     model: "Z650",
     years: ["2017+"],
     link: "https://flipndip.co.uk/collections/kawasaki/products/kawasaki-z650?utm_source=bike-selector",
   },

      {
     brand: "Kawasaki",
     model: "Ninja 650",
     years: ["2017+"],
     link: "https://flipndip.co.uk/collections/kawasaki/products/kawasaki-ninja-650?utm_source=bike-selector",
   },

      {
     brand: "Kawasaki",
     model: "Ninja 400",
     years: ["2018 - 2023"],
     link: "https://flipndip.co.uk/collections/kawasaki/products/kawasaki-ninja-400?utm_source=bike-selector",
   },

      {
     brand: "Kawasaki",
     model: "Ninja 250",
     years: ["2018 - 2020"],
     link: "https://flipndip.co.uk/collections/kawasaki/products/kawasaki-ninja-250?utm_source=bike-selector",
   },

    {
     brand: "Kawasaki",
     model: "Z400",
     years: ["2019 - 2020"],
     link: "https://flipndip.co.uk/collections/kawasaki/products/kawasaki-z400?utm_source=bike-selector",
   },
   {
     brand: "Kawasaki",
     model: "Z250",
     years: ["2019"],
     link: "https://flipndip.co.uk/collections/kawasaki/products/kawasaki-z250?utm_source=bike-selector",
   },
  
  

   {
     brand: "KTM",
     model: "690 SMC",
     years: ["2019 +"],
     link: "https://flipndip.co.uk/collections/ktm/products/ktm-690?utm_source=bike-selector",
   },

   {
     brand: "KTM",
     model: "Duke 125",
     years: ["2017 - 2021"],
     link: "https://flipndip.co.uk/products/ktm-duke-125-390?utm_source=bike-selector",
   },

    {
     brand: "KTM",
     model: "Duke 200",
     years: ["2017 - 2021"],
     link: "https://flipndip.co.uk/products/ktm-duke-125-390?utm_source=bike-selector",
   },

    {
     brand: "KTM",
     model: "Duke 390",
     years: ["2017 - 2021"],
     link: "https://flipndip.co.uk/products/ktm-duke-125-390?utm_source=bike-selector",
   },

    {
     brand: "KTM",
     model: "Duke 250",
     years: ["2017 - 2018"],
     link: "https://flipndip.co.uk/products/ktm-duke-125-390?utm_source=bike-selector",
   },

    {
     brand: "KTM",
     model: "790 Duke",
     years: ["2018 - 2023"],
     link: "https://flipndip.co.uk/products/ktm-790-890?utm_source=bike-selector",
   },

    {
     brand: "KTM",
     model: "890 Duke",
     years: ["2020 - 2023"],
     link: "https://flipndip.co.uk/products/ktm-790-890?utm_source=bike-selector",
   },

     {
     brand: "KTM",
     model: "990 Duke",
     years: ["2024+"],
     link: "https://flipndip.co.uk/collections/ktm/products/ktm-990-duke?utm_source=bike-selector",
   },

    {
     brand: "KTM",
     model: "1390 Superduke",
     years: ["2024+"],
     link: "https://flipndip.co.uk/collections/ktm/products/ktm-superduke-1390?utm_source=bike-selector",
   },

   {
     brand: "KTM",
     model: "1290 Superduke R",
     years: ["2014 - 2016", "2017 - 2019", "2019 - 2023"],
     link: [
           "https://flipndip.co.uk/products/ktm-superduke-1290-flip-n-dip-adjustable-bracket?variant=53290898653571&utm_source=bike-selector",
            "https://flipndip.co.uk/products/ktm-superduke-1290-flip-n-dip-adjustable-bracket?variant=53290898653571&utm_source=bike-selector",
            "https://flipndip.co.uk/products/ktm-superduke-1290-flip-n-dip-adjustable-bracket?variant=53290898850179&utm_source=bike-selector",
       ],
   },

   {
     brand: "Suzuki",
     model: "GSXS 1000",
     years: ["2015 - 2020", "2021 - 2023"],
     link: ["https://flipndip.co.uk/products/suzuki-gsxs?variant=42789989941438&utm_source=bike-selector", 
           "https://flipndip.co.uk/products/suzuki-gsxs?variant=42789989974206&utm_source=bike-selector"],
   },

   {
     brand: "Suzuki",
     model: "GSXS 950",
     years: ["2021 - 2023"],
     link: "https://flipndip.co.uk/collections/suzuki/products/suzuki-gsxs?utm_source=bike-selector",
   },

  {
     brand: "Suzuki",
     model: "GSR 750",
     years: ["2011 — 2016"],
     link: "https://flipndip.co.uk/collections/suzuki/products/suzuki-gsr?utm_source=bike-selector",
   },
  
  {
     brand: "Suzuki",
     model: "GSXR 600",
     years: ["2006 - 2010", "2011 - 2019"],
     link: {
       "2006 - 2010": "https://flipndip.co.uk/collections/suzuki/products/suzuki-gsxr-600?variant=43556271325374&utm_source=bike-selector",
       "2011 - 2019": "https://flipndip.co.uk/collections/suzuki/products/suzuki-gsxr-600?variant=43556271259838&utm_source=bike-selector",
     },
   },

   {
     brand: "Suzuki",
     model: "GSXR 750",
     years: ["2006 - 2010", "2011 - 2019"],
     link: [
       "https://flipndip.co.uk/products/suzuki-gsxr-750?variant=43556196876478&utm_source=bike-selector",
       "https://flipndip.co.uk/products/suzuki-gsxr-750?variant=43556196909246&utm_source=bike-selector",
     ],
   },

   {
     brand: "Suzuki",
     model: "GSXR 1000",
     years: ["2006 - 2008", "2009 - 2016", "2017+"],
     link: [
       "https://flipndip.co.uk/collections/suzuki/products/suzuki-gsxr-1000?variant=43556185014462&utm_source=bike-selector",
       "https://flipndip.co.uk/collections/suzuki/products/suzuki-gsxr-1000?variant=43556185112766&utm_source=bike-selector",
       "https://flipndip.co.uk/collections/suzuki/products/suzuki-gsxr-1000?variant=43556185079998&utm_source=bike-selector",
     ],
   },

   {
     brand: "Triumph",
     model: "Daytona 675",
     years: ["2013 - 2017"],
     link: "https://flipndip.co.uk/collections/triumph/products/triumph-street-triple-660-675-765-daytona-675-r?utm_source=bike-selector",
   },

  {
     brand: "Triumph",
     model: "Daytona 660",
     years: ["2024+"],
     link: "https://flipndip.co.uk/collections/triumph/products/triumph-daytona-660?utm_source=bike-selector",
   },

   {
     brand: "Triumph",
     model: "Daytona Moto2 765",
     years: ["2020"],
     link: "https://flipndip.co.uk/collections/triumph/products/triumph-street-triple-660-675-765-daytona-675-r?utm_source=bike-selector",
   },

   {
     brand: "Triumph",
     model: "Street Triple 675 R",
     years: ["2013 - 2016"],
     link: "https://flipndip.co.uk/collections/triumph/products/triumph-street-triple-660-675-765-daytona-675-r?utm_source=bike-selector",
   },

   {
     brand: "Triumph",
     model: "Street Triple 675 RX",
     years: ["2015 - 2016"],
     link: "https://flipndip.co.uk/collections/triumph/products/triumph-street-triple-660-675-765-daytona-675-r?utm_source=bike-selector",
   },

   {
     brand: "Triumph",
     model: "Street Triple 765 R",
     years: ["2017 - 2022"],
     link: "https://flipndip.co.uk/collections/triumph/products/triumph-street-triple-660-675-765-daytona-675-r?utm_source=bike-selector",
   },

   {
     brand: "Triumph",
     model: "Street Triple 765 RS",
     years: ["2017 - 2022"],
     link: "https://flipndip.co.uk/collections/triumph/products/triumph-street-triple-660-675-765-daytona-675-r?utm_source=bike-selector",
   },

   {
     brand: "Triumph",
     model: "Street Triple 765 S",
     years: ["2017 - 2020"],
     link: "https://flipndip.co.uk/collections/triumph/products/triumph-street-triple-660-675-765-daytona-675-r?utm_source=bike-selector",
   },

   {
     brand: "Triumph",
     model: "Street Triple 675",
     years: ["2013 - 2016"],
     link: "https://flipndip.co.uk/collections/triumph/products/triumph-street-triple-660-675-765-daytona-675-r?utm_source=bike-selector",
   },

   {
     brand: "Yamaha",
     model: "MT07",
     years: ["2014 - 2025"],
     link: "https://flipndip.co.uk/collections/yamaha/products/mt07-adjustable-flip-plate-flip-n-dip?utm_source=bike-selector",
 },

    {
     brand: "Yamaha",
     model: "Tenere T7 700",
     years: ["2019 - 2024"],
     link: "https://flipndip.co.uk/products/yamaha-tenere-t7?utm_source=bike-selector",
   },
  
   {
       brand: "Yamaha",
       model: "R7",
       years: ["2022 - 2024"],
       link: "https://flipndip.co.uk/products/yamaha-r7?utm_source=bike-selector",
     },
   {
       brand: "Yamaha",
       model: "MT09",
       years: ["2014 - 2016", "2017 - 2019", "2020 - 2023", "2024+"],
       link: {
         "2014 - 2016": "https://flipndip.co.uk/products/yamaha-mt09?utm_source=bike-selector",
         "2017 - 2019": "https://flipndip.co.uk/collections/yamaha/products/yamaha-mt09?variant=41218876440766&utm_source=bike-selector",
         "2020 - 2023" : "https://flipndip.co.uk/collections/yamaha/products/yamaha-mt09?variant=41576448065726&utm_source=bike-selector",
         "2024+": "https://flipndip.co.uk/collections/brackets/products/yamaha-mt09?variant=44335956983998&utm_source=bike-selector",
       }
     },
     {
       brand: "Yamaha",
       model: "MT10",
       years: ["2016 - 2024"],
       link: "https://flipndip.co.uk/products/yamaha-mt10-flip-n-dip-adjustable-bracket?utm_source=bike-selector",
     },
     {
       brand: "Yamaha",
       model: "R1",
       years: ["2004 - 2014", "2015 - 2024"],
       link: {
         "2004 - 2014": "https://flipndip.co.uk/products/yamaha-r1-flip-plate?variant=41487193997502&utm_source=bike-selector",
         "2015 - 2024": "https://flipndip.co.uk/products/yamaha-r1-flip-plate?variant=41487193964734&utm_source=bike-selector"
       },
     },

     {
       brand: "Yamaha",
       model: "R6",
       years: ["2003 - 2005", "2006 - 2016", "2017+"],
       link: {
         "2006 - 2016": "https://flipndip.co.uk/collections/yamaha/products/yamaha-r6-06-16-flip-n-dip-adjustable-bracket?variant=40949204091070&utm_source=bike-selector",
         "2017+": "https://flipndip.co.uk/collections/yamaha/products/yamaha-r6-06-16-flip-n-dip-adjustable-bracket?variant=40949204123838&utm_source=bike-selector",
         "2003 - 2005": "https://flipndip.co.uk/collections/yamaha/products/yamaha-r6-06-16-flip-n-dip-adjustable-bracket?variant=43702357819582"
       },
     },
     {
       brand: "Yamaha",
       model: "Raptor 700",
       years: ["All years"],
       link: "https://flipndip.co.uk/products/yamaha-raptor-700?utm_source=bike-selector",
     },
   {
       brand: "Yamaha",
       model: "XJ6",
       years: ["2006 - 2016"],
       link: "https://flipndip.co.uk/products/yamaha-xj6?utm_source=bike-selector",
     },
  {
       brand: "Yamaha",
       model: "XJ6 N",
       years: ["2013 - 2016"],
       link: "https://flipndip.co.uk/products/yamaha-xj6?utm_source=bike-selector",
     },
    {
     brand: "Yamaha",
     model: "TRACER 9",
     years: ["2015 - 2017"],
     link: "https://flipndip.co.uk/products/yamaha-mt09-tracer?utm_source=bike-selector",
   },
  {
     brand: "Yamaha",
     model: "TRACER 9 GT",
     years: ["2021+"],
     link: "https://flipndip.co.uk/products/yamaha-tracer-9-gt?utm_source=bike-selector",
   },
 
  {
       brand: "Yamaha",
       model: "XJ6-Diversion F - FZ6R",
       years: ["2010 - 2016"],
       link: "https://flipndip.co.uk/products/yamaha-xj6?utm_source=bike-selector",
     },
   {
       brand: "Yamaha",
       model: "MT125",
       years: ["2014 — 2019", "2020 — 2023"],
       link: "https://flipndip.co.uk/products/yamaha-mt125?utm_source=bike-selector",
     },
  {
       brand: "Yamaha",
       model: "R125",
       years: ["2008 — 2013", "2014 - 2018", "2019+"],
       link: {
         "2008 — 2013": "https://flipndip.co.uk/collections/yamaha/products/yamaha-r125?variant=42652329312446&utm_source=bike-selector",
         "2014 - 2018": "https://flipndip.co.uk/collections/yamaha/products/yamaha-r125?variant=42652329345214&utm_source=bike-selector",
         "2019+": "https://flipndip.co.uk/collections/yamaha/products/yamaha-r125?variant=43314524487870&utm_source=bike-selector"
       },
     },
 {
     brand: "Yamaha",
     model: "MT07 Tracer",
     years: ["2016 - 2019"],
     link: "https://flipndip.co.uk/products/yamaha-mt07-tracer?utm_source=bike-selector",
   },  
     {
       brand: "Yamaha",
       model: "R3",
       years: ["2015 - 2023"],
       link: "https://flipndip.co.uk/products/yamaha-r3?utm_source=bike-selector",
     },
     {
       brand: "Yamaha",
       model: "MT03",
       years: ["2016 - 2023"],
       link: "https://flipndip.co.uk/products/yamaha-r3?utm_source=bike-selector",
     },
];



//   function onlyUnique(value, index, self) {
//     return self.indexOf(value) === index;
//   }

// function sortModel( a, b ) {
//   if ( a.model < b.model ){
//     return -1;
//   }
//   if ( a.model > b.model ){
//     return 1;
//   }
//   return 0;
// }

// function slugify(text) {
//   return text
//     .toString()
//     .toLowerCase()
//     .trim()
//     .replace(/[\s_]+/g, '-')           // Replace spaces and underscores with -
//     .replace(/[^\w\-]+/g, '')          // Remove all non-word chars
//     .replace(/\-\-+/g, '-');           // Replace multiple - with single -
// }



// OLD
const autoModels = window.models || window.oldmodels || [];

$(function () {
  // --- helpers ---
  const cleanText = s => (s ?? "")
    .toString()
    .normalize("NFKC")
    .replace(/[\u200B-\u200D\uFEFF]/g, "") // zero-width chars
    .replace(/\u00A0/g, " ")               // non-breaking space -> normal space
    .replace(/\s+/g, " ")
    .trim();

  const slugify = (s = "") =>
    cleanText(s)
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  const onlyUnique = (v, i, a) => a.indexOf(v) === i;

  const sortByText = (a, b) =>
    cleanText(a).localeCompare(cleanText(b), undefined, { sensitivity: "base" });

  function setPlaceholder($sel, text, enabled = false) {
    $sel.empty()
      .append($("<option>", { value: "", text, disabled: true, selected: true }))
      .prop("disabled", !enabled)
      .toggleClass("inactive", !enabled);
  }

  // --- build lookups ---
  // --- build lookups ---
const mergedModels = new Map();

for (const raw of autoModels) {
  const brandKey = cleanText(raw.brand);
  const modelKey = cleanText(raw.model);
  const mergedKey = `${brandKey}|||${modelKey}`.toLowerCase();

  const years = Array.isArray(raw.years)
    ? raw.years.map(cleanText).filter(Boolean)
    : [];

  if (!mergedModels.has(mergedKey)) {
    mergedModels.set(mergedKey, {
      ...raw,
      brand: brandKey,
      model: modelKey,
      years: [...years],
      link: raw.link
    });
  } else {
    const existing = mergedModels.get(mergedKey);

    // merge years uniquely
    const seenYears = new Set(existing.years.map(y => cleanText(y).toLowerCase()));
    for (const y of years) {
      const yKey = cleanText(y).toLowerCase();
      if (!seenYears.has(yKey)) {
        seenYears.add(yKey);
        existing.years.push(y);
      }
    }

    // merge links if possible
    const oldLink = existing.link;
    const newLink = raw.link;

    if (!oldLink && newLink) {
      existing.link = newLink;
    } else if (Array.isArray(oldLink) || Array.isArray(newLink)) {
      const oldArr = Array.isArray(oldLink) ? oldLink : (oldLink ? [oldLink] : []);
      const newArr = Array.isArray(newLink) ? newLink : (newLink ? [newLink] : []);
      existing.link = [...oldArr, ...newArr];
    } else if (
      oldLink && typeof oldLink === "object" &&
      newLink && typeof newLink === "object" &&
      !Array.isArray(oldLink) &&
      !Array.isArray(newLink)
    ) {
      existing.link = { ...oldLink, ...newLink };
    }
  }
}

const mergedAutoModels = Array.from(mergedModels.values());

const brands = mergedAutoModels
  .map(m => m.brand)
  .filter(Boolean)
  .filter(onlyUnique)
  .sort(sortByText);

const brandToModels = new Map();
const modelByName = new Map();

for (const m of mergedAutoModels) {
  const brandKey = m.brand;
  const modelKey = m.model;
  const key = `${brandKey}|||${modelKey}`.toLowerCase();

  if (!brandToModels.has(brandKey)) {
    brandToModels.set(brandKey, []);
  }

  brandToModels.get(brandKey).push(m);
  modelByName.set(key, m);
}

for (const list of brandToModels.values()) {
  list.sort((a, b) => sortByText(a.model, b.model));
}




  // sort model lists
  for (const list of brandToModels.values()) {
    list.sort((a, b) => sortByText(a.model, b.model));
  }

  // --- DOM refs ---
  const $brands = $("#brands");
  const $models = $("#models");
  const $years = $("#years");

  // --- initial placeholders ---
  setPlaceholder($brands, "Select the brand ↓", true);
  setPlaceholder($models, "Select the model ↓", false);
  setPlaceholder($years, "Select the year ↓", false);

  // populate brands
  for (const b of brands) {
    $brands.append($("<option>", { value: b, text: b }));
  }

  // --- events ---
  $brands.on("change.bikeSel", function () {
    const brand = cleanText($(this).val());
    if (!brand) return;

    setPlaceholder($models, "Select the model ↓", true);
    setPlaceholder($years, "Select the year ↓", false);

    const list = brandToModels.get(brand) || [];

    // See all
    $models.append(
      $("<option>", {
        value: "__see_all__",
        text: `→ See all ${brand}`
      })
    )
      .prop("disabled", false)
      .removeClass("inactive");

    // Deduped models
    const seenModels = new Set();

    for (const m of list) {
      const modelName = cleanText(m.model);
      const key = modelName.toLowerCase();

      if (!modelName || seenModels.has(key)) continue;
      seenModels.add(key);

      $models.append(
        $("<option>", {
          value: modelName,
          text: modelName
        })
      );
    }
  });

  $models.on("change.bikeSel", function () {
    const selected = cleanText($(this).val());
    if (!selected) return;

    setPlaceholder($years, "Select the year ↓", true);

    if (selected === "__see_all__") {
      const brandSlug = slugify($brands.val() || "");
      if (brandSlug) window.location.href = `/collections/${brandSlug}`;
      return;
    }

    const brand = cleanText($brands.val());
    const model = modelByName.get(`${brand}|||${selected}`.toLowerCase());

    if (!model || !Array.isArray(model.years) || model.years.length === 0) {
      setPlaceholder($years, "No years available", false);
      return;
    }

    const toLink = (year, idx) => {
      const L = model.link;
      if (!L) return null;
      if (typeof L === "string") return L;
      if (Array.isArray(L)) return L[idx] || null;
      if (typeof L === "object") return L[year] || null;
      return null;
    };

    model.years.forEach((year, idx) => {
      const cleanYear = cleanText(year);
      const url = toLink(cleanYear, idx);
      const $opt = $("<option>", { value: String(cleanYear), text: String(cleanYear) });
      if (url) $opt.data("link", url);
      $years.append($opt);
    });
  });

  $years.on("change.bikeSel", function () {
    const val = cleanText($(this).val());
    if (!val) return;

    const link = $(this).find(":selected").data("link");
    const selectedModel = cleanText($models.val());
    const selectedBrand = cleanText($brands.val());

    try {
      const m = modelByName.get(`${selectedBrand}|||${selectedModel}`.toLowerCase());
      if (window.gtag && m) {
        gtag("event", "bike_selector_used", {
          event_category: m.brand,
          event_label: selectedModel
        });
      }
    } catch (_) {}

    if (link) window.location.href = link;
  });

  // --- brand auto-select on /collections/[brand] ---
  const match = window.location.pathname.match(/\/collections\/([^\/?#]+)/i);
  if (match && match[1]) {
    const slug = match[1].toLowerCase();
    const matchBrand = brands.find(b => slugify(b) === slug);
    if (matchBrand) {
      (window.requestAnimationFrame || setTimeout)(() => {
        $brands.val(matchBrand).trigger("change");
      }, 0);
    }
  }
});


(function bikeTypeaheadPerRange() {
  if (typeof autoModels === "undefined") {
    console.warn("[bike-typeahead] autoModels not found.");
    return;
  }

  const $input = $("#bike-typeahead-input");
  if (!$input.length) return;

  // Create portal once
  let $portal = $("#bike-typeahead-portal");
  if (!$portal.length) {
    $portal = $('<ul id="bike-typeahead-portal" role="listbox" aria-label="Bike results"></ul>');
    $(document.body).append($portal);
  }

  // ---------- helpers ----------
  const clean = (s = "") => (s ?? "")
    .toString()
    .normalize("NFKC")
    .replace(/[\u200B-\u200D\uFEFF]/g, "")
    .replace(/\u00A0/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  function prettyRangeLabel(raw) {
    const str = clean(raw).replace(/[–—]/g, "-");
    const m = str.match(/^([^()]+)(\s*\(.*\))?$/);
    const head = (m?.[1] || str)
      .replace(/\s*-\s*/g, "-")
      .replace(/\s*\+\s*$/, "+")
      .replace(/\s+/g, " ");
    const tail = m?.[2] ? m[2].replace(/\s+/g, " ") : "";
    return head + tail;
  }

  function urlFor(model, idx) {
    const L = model.link;
    if (!L) return null;
    if (Array.isArray(L)) return L[idx] || L[L.length - 1] || null;
    if (typeof L === "string") return L;
    if (typeof L === "object") {
      const wanted = prettyRangeLabel(model.years[idx] || "");
      for (const k in L) {
        if (prettyRangeLabel(k).toLowerCase() === wanted.toLowerCase()) return L[k];
      }
      const firstKey = Object.keys(L)[0];
      return firstKey ? L[firstKey] : null;
    }
    return null;
  }

  // --- tokenised search ---
  function makeTokens(...parts) {
    const set = new Set();
    for (let p of parts) {
      if (!p) continue;
      p = clean(p).toLowerCase();
      p = p.replace(/[–—]/g, "-").replace(/[(),/]/g, " ").replace(/[\-+]/g, " ");
      p = p.replace(/([a-z])(\d)/gi, "$1 $2").replace(/(\d)([a-z])/gi, "$1 $2");
      p = p.replace(/\s+/g, " ").trim();
      if (!p) continue;
      const toks = p.split(" ");
      for (const t of toks) {
        set.add(t);
        set.add(t.replace(/\s+/g, ""));
      }
    }
    return Array.from(set);
  }

  function queryTokens(q) {
    const parts = clean(q).toLowerCase().split(/\s+/).filter(Boolean);
    const set = new Set();
    for (const part of parts) {
      for (const t of makeTokens(part)) set.add(t);
    }
    return Array.from(set);
  }

  function tokensMatch(entryTokens, qTokens) {
    if (!qTokens.length) return false;
    return qTokens.every(qt => entryTokens.some(t => t === qt || t.startsWith(qt)));
  }

  // Build index: one result per (brand, model, range)
  const perRangeIndex = [];
  const seen = new Set();

  for (const raw of autoModels) {
    const brand = clean(raw.brand);
    const model = clean(raw.model);
    const years = Array.isArray(raw.years) ? raw.years.map(clean) : [];

    years.forEach((rawLabel, i) => {
      const label = prettyRangeLabel(rawLabel);
      const href = urlFor({ ...raw, years }, i);
      if (!href) return;

      const key = `${brand}|${model}|${label}|${href}`.toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);

      perRangeIndex.push({
        brand,
        model,
        label,
        url: href,
        hay: (brand + " " + model + " " + label).toLowerCase(),
        tokens: makeTokens(brand, model, label)
      });
    });
  }

  // ---------- UI / portal ----------
  function positionPortal() {
    const r = $input[0].getBoundingClientRect();
    $portal.css({
      position: "fixed",
      zIndex: 999999,
      top: (r.bottom + 6) + "px",
      left: r.left + "px",
      width: r.width + "px"
    });
  }

  let activeIndex = -1;

  function render(items) {
    $portal.empty();

    if (!items.length) {
      $portal.append('<li class="is-empty" aria-disabled="true" style="padding:10px 12px; color:#aaa;">No matches</li>');
    } else {
      const frag = document.createDocumentFragment();

      items.forEach((it, i) => {
        const li = document.createElement("li");
        li.setAttribute("role", "option");
        li.className = "result-item";

        const a = document.createElement("a");
        a.href = it.url;
        a.target = "_self";
        a.rel = "nofollow";
        a.textContent = `${it.brand} ${it.model} - ${it.label}`;

        a.onmouseenter = () => {
          activeIndex = i;
          updateActive();
        };

        a.onfocus = () => {
          activeIndex = i;
          updateActive();
        };

        li.appendChild(a);
        frag.appendChild(li);
      });

      $portal[0].appendChild(frag);
    }

    showPortal();
    $input.attr("aria-expanded", "true");
    activeIndex = -1;
    updateActive();
    positionPortal();
  }

  function updateActive() {
    const els = $portal.find("li.result-item").toArray();
    els.forEach((el, idx) => el.classList.toggle("is-active", idx === activeIndex));
  }

  function showPortal() {
    $portal.show();
  }

  function clearPortal() {
    $portal.hide().empty();
    $input.attr("aria-expanded", "false");
    activeIndex = -1;
  }

  // ---- hardened close + navigation ----
  let closeTimer = null;

  $input.on("blur", () => {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(clearPortal, 280);
  });

  $portal.on("pointerdown mousedown touchstart", (e) => {
    clearTimeout(closeTimer);
    e.stopPropagation();
  });

  function go(href) {
    if (!href) return;

    try {
      clearTimeout(closeTimer);
      clearPortal();
      window.location.assign(href);
      setTimeout(() => {
        if (document.visibilityState === "visible") window.location.href = href;
      }, 50);
    } catch (err) {
      const tmp = document.createElement("a");
      tmp.href = href;
      document.body.appendChild(tmp);
      tmp.click();
      tmp.remove();
    }
  }

  $portal.on("pointerdown", "a", function (e) {
    e.preventDefault();
    e.stopPropagation();
    go(this.getAttribute("href"));
  });

  $portal.on("click", "a", function (e) {
    e.preventDefault();
    e.stopPropagation();
    go(this.getAttribute("href"));
  });

  // --- search (tokenised) ---
  function search(qRaw) {
    const q = clean(qRaw);
    if (!q) {
      clearPortal();
      return;
    }

    const qTok = queryTokens(q);

    let results = perRangeIndex.filter(it => tokensMatch(it.tokens, qTok));

    const score = (it) => {
      let s = 0;
      for (const qt of qTok) {
        for (const t of it.tokens) {
          if (t === qt) s += 3;
          else if (t.startsWith(qt)) s += 2;
        }
      }
      return -s;
    };

    results = results
      .sort((a, b) =>
        score(a) - score(b) ||
        a.brand.localeCompare(b.brand) ||
        a.model.localeCompare(b.model) ||
        a.label.localeCompare(b.label)
      )
      .slice(0, 30);

    render(results);
  }

  // Events
  let t;

  $input.on("input", function () {
    clearTimeout(t);
    t = setTimeout(() => search(this.value), 80);
  });

  $input.on("focus", function () {
    if (clean(this.value)) search(this.value);
    positionPortal();
  });

  // Keyboard nav and Enter-to-go
  $(document).on("keydown", function (e) {
    if ($portal.is(":hidden")) return;

    const links = $portal.find("a").toArray();
    if (!links.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      activeIndex = Math.min(activeIndex + 1, links.length - 1);
      updateActive();
      links[activeIndex]?.focus({ preventScroll: true });
      links[activeIndex]?.scrollIntoView({ block: "nearest" });
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      activeIndex = Math.max(activeIndex - 1, 0);
      updateActive();
      links[activeIndex]?.focus({ preventScroll: true });
      links[activeIndex]?.scrollIntoView({ block: "nearest" });
    } else if (e.key === "Enter") {
      if (document.activeElement === $input[0]) {
        e.preventDefault();
        const el = links[activeIndex] || links[0];
        if (el && el.href) go(el.href);
      }
    } else if (e.key === "Escape") {
      clearPortal();
      $input.trigger("focus");
    }
  });

  window.addEventListener("scroll", () => {
    if ($portal.is(":visible")) positionPortal();
  }, true);

  window.addEventListener("resize", () => {
    if ($portal.is(":visible")) positionPortal();
  });
})();

(() => {
  const phrases = [
    "for those who don’t hang about 💨",
    "for clean setups 🧼",
    "for your bike 💪",
    "for keeping it low-key 🥷🏻",
    "built for riders on the move 🚀",
    "built to blend in 👀"
  ];

  const el = document.getElementById("hero-rotator");
  if (!el) return;

  let pool = [...phrases];

  const getNext = () => {
    if (!pool.length) pool = [...phrases];
    const i = Math.floor(Math.random() * pool.length);
    return pool.splice(i, 1)[0];
  };

  // -------- SET RANDOM LINE ON LOAD (NO ANIMATION) --------
  el.textContent = getNext();

  /*
  // -------- ENABLE THIS IF YOU WANT ROTATION BACK --------
  setInterval(() => {
    el.classList.add("fade-out");

    setTimeout(() => {
      el.textContent = getNext();
      el.classList.remove("fade-out");
      el.classList.add("fade-in");

      setTimeout(() => {
        el.classList.remove("fade-in");
      }, 500);

    }, 500);

  }, 6000);
  */

})();